<template>
    <div>
        <div class="hp-scormCon">
            <component
                :is="scormVersion"
                v-model="scormUrl"
                :res-id="resId"
                :update-id="updateId"
                :api-data="apiData"
            />
        </div>
    </div>
</template>

<script>
import Scorm12 from './scorm2.vue';
import Scorm2004 from './scorm.vue';

export default {
    name:'commonScrom',
    components: {
        Scorm2004,
        Scorm12
    },
    props: {
        id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            showSlider: true,
            scormVersion: '',
            Menulist: [],
            curActive: '1',
            courseName: '',
            catalogName: '',
            scormUrl: '',
            resId: 0,
            objapi: '',
            apiData: [],
            catalogId: '',
            updateId:'',
            version:1.2
        };
    },
    created() {
    },
    beforeMount() {

    },
    mounted() {
        this.resId = this.id;
        this.getScormInfoById();
    },
    methods: {
        // 课程基本信息回显
        async getScormInfoById() {
            const params = {
                id: this.resId,
            };
            try {
                const { data } = await this.$api.zuoye.getScormInfoById(params);
                if (data.sourceSign === '1.2') {
                    this.scormVersion = 'Scorm12';
                } else {
                    this.scormVersion = 'Scorm2004';
                }
                if(data.scoCatalogDtoList){
                    // window.location.hostname
                    this.scormUrl = window.location.protocol+'//' + window.location.hostname + data.scoCatalogDtoList[0].url;
                    // this.scormUrl = 'https://hrss-main.testing3.wdeduc.com' + data.scoCatalogDtoList[0].url;
                    // this.scormUrl = data.scoCatalogDtoList[0].visitUrl
                    // this.apiData = [
                    //     {"scoId":"","variableKey":"cmi.student_preference.audio","variableValue":"1"},
                    //     {"scoId":"","variableKey":"mos.timestampTentative","variableValue":"1610967403"},
                    //     {"scoId":"","variableKey":"cmi.core.lesson_status","variableValue":"incomplete"},
                    //     {"scoId":"","variableKey":"cmi.core.lesson_location","variableValue":"0$ā2"},
                    //     {"scoId":"","variableKey":"cmi.core.exit","variableValue":"logout"},
                    //     {"scoId":"","variableKey":"mos.dateRemonte","variableValue":"2021-01-18T10:56:49.91"}]
                    if(data.scoCatalogDtoList[0].parameter) {
                        this.apiData.push({
                            scoId: this.playerScoId,
                            variableKey: 'ro.launch_data',
                            variableValue: data.scoCatalogDtoList[0].parameter,
                        });
                    }
                }
            } catch (err) {
                console.debug(err);
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next();
    },
};
</script>

<style lang="stylus">
    .hp-scormCon {
       padding:20px;
    }
</style>
